import { render, staticRenderFns } from "./PanelCompanyInvoice.vue?vue&type=template&id=1445a2db&"
import script from "./PanelCompanyInvoice.vue?vue&type=script&lang=js&"
export * from "./PanelCompanyInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports